module.exports = __webpack_public_path__ + "img/jpge.e0b84a2.svg";